<template>
  <div>
    <v-card-text class="px-4">
      <p v-if="!listingAlbums.length" class="grey--text pf-font-14">
        No albums found, please choose upload new image.
      </p>
      <template v-else-if="currentAlbum">
        <v-layout class="flex-space-between">
          <h5 class="mb-2">Select a photo and click continue.</h5>
          <v-btn
            :disabled="!!!selectedPhoto"
            class="pf-btn-text-white pf-bg-teal"
            @click="submit"
          >
            Continue
          </v-btn>
        </v-layout>
        <v-layout class="flex-start">
          <v-btn icon flat class="pf-text-teal" @click="backFromPhotos" v-if="currentAlbum">
            <v-icon size="24" class="pr-1">arrow_back</v-icon>
          </v-btn>
          <span v-if="currentAlbum" class="grey--text">{{ currentAlbum.photo ? currentAlbum.photo.length : 0 }}
            Photos</span>
        </v-layout>
        <v-layout wrap>
          <isotope ref="profileAlbumImages" :options="getOptions()" v-images-loaded:on.progress="layoutAllPhotos"
            :list="currentAlbum.photo" class="pf-width-100p">
            <v-flex v-for="(photo, p) in currentAlbum.photo" :key="p" class="pa-1 chapter-item xs12 sm3">
              <div class="pf-cursor-pointer pf-pos-relative flex-center" @click="selectPhoto(photo)"
                :class="{ 'pf-border-green-3': selectedPhotoURL === photo.photo.original_url }"
                title="Click to add">
                <img class="pf-width-100p"
                  :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`"
                  :alt="photo.photo.caption">
                <div class="image-metadata absolute-top-right flex-center font-weight-medium">{{ photo.photo.size ?
                  `${(photo.photo.size / 1000000).toFixed(2)} MB` : 'Size unknown' }}</div>
              </div>
            </v-flex>
          </isotope>
        </v-layout>
      </template>
      <v-layout v-else wrap>
        <h5 class="mb-2">Choose an album to view the photos.</h5>
        <isotope ref="albumList" :options="getOptions()" v-images-loaded:on.progress="layoutAlbums"
          :list="listingAlbums" class="pf-width-100p">
          <v-flex v-for="(albumItem, a) in listingAlbums" :key="a"
            class="pa-1 chapter-item pf-box-shadow xs12 sm3 pf-cursor-pointer" @click="viewAlbum(albumItem, a)">
            <div class="pf-pos-relative flex-center">
              <img v-if="albumItem.default_photo" class="pf-width-100p"
                :src="`${albumItem.default_photo.thumb_url ? albumItem.default_photo.thumb_url : albumItem.default_photo.webview_url ? albumItem.default_photo.webview_url : albumItem.default_photo.original_url}`">
              <img v-else class="pf-width-100p" src="/static/album-icon.jpg">
            </div>
            <v-layout class="wrap border-top-teal-4">
              <v-flex xs10 class="pa-1 font-weight-medium">{{ albumItem.name || 'Un-named' }}</v-flex>
              <v-flex xs2 class="text-center pa-1 white--text font-weight-light pf-bg-teal">{{ albumItem.photo ?
                albumItem.photo.length : 0 }}</v-flex>
            </v-layout>
          </v-flex>
        </isotope>
      </v-layout>
    </v-card-text>
  </div>
</template>
<script>

/* global session store */
import Vue from 'vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import { getCollection, sortList, imageUrlToBase64 } from '../helpers/helpers';
import isotope from '../components/Isotope';
import imagesLoaded from 'vue-images-loaded';
import swal from 'sweetalert2';

Vue.use(VueYouTubeEmbed);
export default {
  name: 'app-albums',
  components: {
    isotope,
    imagesLoaded,
  },
  directives: {
    imagesLoaded
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    size: {
      type: Object,
      default: () => ({ width: 630, height: 630 })
    },
  },
  data: () => ({
    session: session,
    isActive: false,
    currentAlbum: null,
    currentAlbumIndex: -1,
    selectedPhoto: null,
    selectedPhotoURL: null,
  }),
  computed: {
    getModalWidth () {
      return this.$vuetify.breakpoint.smAndUp ? this.width : '100%';
    },
    albumList: {
      get () {
        return store.state.AlbumPhotosPopulated;
      },
      set (value) {
        store.commit('setAlbumPhotosPopulated', value);
      }
    },
    listingAlbums () {
      return this.albumList && this.albumList.length ? this.albumList.filter(x => x.photo && x.photo.length) : [];
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.loadAlbums();
  },
  methods: {
    async loadAlbums () {
      if (this.accountId && !this.albumList.length) {
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          where.account = this.accountId;
        }
        let populate = { path: 'photo.photo', select: 'filename mimetype size original_url thumb_url webview_url caption' };
        let { error, data } = await getCollection('Album', true, 0, populate, where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.albumList = sortList('Album', data, 'Account', sessionUser.adminUser ? this.accountId : 'Me');
          }
        }
      }
    },
    viewAlbum (album, index) {
      this.currentAlbum = album;
      this.currentAlbumIndex = index;
      this.selectedPhoto = null;
      this.selectedPhotoURL = null;
    },
    backFromPhotos () {
      this.currentAlbum = null;
      this.currentAlbumIndex = -1;
    },
    layoutAlbums () {
      if (this.$refs.albumList) {
        this.$refs.albumList.layout('masonry');
      }
    },
    getOptions: function () {
      return {
        layoutMode: 'masonry',
        masonry: {
          columnWidth: '.chapter-item',
          // gutter: 8
        },
        percentPosition: true,
        originLeft: true,
        itemSelector: '.chapter-item'
      };
    },
    layoutAllPhotos () {
      if (this.$refs.profileAlbumImages) {
        this.$refs.profileAlbumImages.layout('masonry');
      }
    },
    isSelectable (photo) {
      if (photo && photo.photo && photo.photo.width && photo.photo.height) {
        return photo.photo.width >= this.size.width && photo.photo.height >= this.size.height;
      }
      return false;
    },
    selectPhoto (photo) {
      const self = this;
      if (photo && photo.photo && photo.photo.original_url) {
        const img = new Image();
        img.onload = async () => {
          if (img.width >= self.size.width && img.height >= self.size.height) {
            // Get the binary blob of the image
            const base64 = await imageUrlToBase64(photo.photo.original_url);
            self.selectedPhoto = base64;
            self.selectedPhotoURL = photo.photo.original_url;
            self.submit();
          } else {
            swal.fire({
              type: 'warning',
              title: `Small Image`,
              text: `The photo must be at least ${self.size.width}x${self.size.height} pixels. The selected photo is ${img.width}x${img.height} pixels.`,
              showConfirmButton: true
            });
          }
        };
        img.src = photo.photo.original_url;
      }
    },
    submit () {
      if (this.selectedPhoto) {
        // Get the base64 string of the selected photo, it's a url now.
        this.$emit('submit', this.selectedPhoto);
      }
    },
  }
};
</script>


<style scoped></style>


// WEBPACK FOOTER //
// src/components/AppAlbums.vue